module.exports = __webpack_public_path__ + "static/img/中国.aa5a2d51.jpg";